<template>
    <div>
        <!-- Modal de Programação de Entrega -->
        <div class="modal fade" id="ocEntregaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Ordem de Compra <span v-if="oc" class="badge badge-secondary">#{{ oc.id_aquisicao_ordem_compra }}</span></h5>
                        <button type="button" class="close" @click="fechar_modal()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info">Programação de Entregas</div>

                        <div v-if="!oc">
                            <az-empty-state />
                        </div>

                        <div v-else-if="oc && oc.entregas">
                            <template v-for="(entrega, index) in oc.entregas">
                                <div :key="index" class="form-row" v-if="!entrega.excluido">
                                    <div class="col col-12 col-md-3">
                                        <az-input
                                            sizing="sm"
                                            v-model="entrega.dt_entrega"
                                            required 
                                            :validate="validate"
                                            type="date">
                                            <template v-slot:button-pre>
                                                <div class="input-group-prepend">
                                                    <button class="btn btn-outline-danger" type="button" @click="entrega.excluido = true">
                                                        <i class="fas fa-minus"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                    <div class="col col-12 col-md-9">
                                        <az-input
                                            sizing="sm"
                                            v-model="entrega.st_observacoes"
                                            placeholder="Observações..."
                                            type="text" />    
                                    </div>
                                </div>
                            </template>

                            <button class="btn btn-sm btn-outline-primary mt-3" @click="oc.entregas.push({ dt_entrega: '', st_observacoes: '', excluido: false })">
                                <i class="fas fa-plus"></i>
                            </button>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar_modal()">Fechar</button>
                        <az-submit @click="atualizar()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import AzSubmit from '../../util/AzSubmit.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';

export default {
    data() {
        return { 
            oc: null, 
            validate: false, 
        }
    },

    components: { 
        AzSubmit,
        AzInput,
        AzEmptyState, 
    },
  
    methods: { 
        fechar_modal() { 
            $('#ocEntregaModal').modal('hide');
        },

        atualizar () { 
            this.$util.atualizar(this, {
                service: 'aquisicao',
                func: 'oc_entregas',
                dados: {
                    id_aquisicao_ordem_compra: this.oc.id_aquisicao_ordem_compra,
                    entregas: this.oc.entregas
                },
                modal: 'ocEntregaModal',
                toast: true, 
                callback: () => { 
                    this.$emit('refresh');
                }
            });
        },

        abrir(id) { 
            this.oc = null; 
            this.validate = false;

            this.$nextTick(() => { 
                $('#ocEntregaModal').modal('show');

                this.$util.load(this, {
                    service: 'aquisicao_ocs',
                    func: 'show',
                    parms: {
                        id: id,
                    },
                    loadTo: res => {
                        if ( !res ) {
                            this.$toast.add({
                                severity: "error",
                                summary: "Atenção",
                                detail: "OC não identificada: " + id,
                                life: 3000
                            });
                            return;
                        }

                        this.oc = res;
                    }
                });
            });
        }
    }

}
</script>
